import { hasUserInput } from '../model/stats';
import type { KinklistDoc } from '../model/types';
import type { DocStore } from '../state/store.svelte';
import { strings } from '../strings';
import type { Toasts } from '../ui/toasts.svelte';

/**
 * Brings an imported list (share link, file, legacy link) into the app.
 * If the current list has ratings or comments, the user is asked first
 * (SPEC §6.8); either way the replacement can be undone.
 */
export class Importer {
  pending: KinklistDoc | null = $state.raw(null);
  readonly #store: DocStore;
  readonly #toasts: Toasts;

  constructor(store: DocStore, toasts: Toasts) {
    this.#store = store;
    this.#toasts = toasts;
  }

  offer(doc: KinklistDoc): void {
    if (hasUserInput(this.#store.doc)) this.pending = doc;
    else this.#replace(doc);
  }

  accept(): void {
    const doc = this.pending;
    this.pending = null;
    if (doc) this.#replace(doc);
  }

  dismiss(): void {
    this.pending = null;
  }

  #replace(doc: KinklistDoc) {
    this.#store.replace(doc);
    this.#toasts.show(strings.sharedOpened, {
      action: { label: strings.undo, run: () => this.#store.undo() },
    });
  }
}
